(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider-custom"] && !Shopify.designMode) return;
  try {
    
  class HeroSliderCustom extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hsc-slide]'));

      // Make only the first slide navigate when the non-interactive banner area is clicked.
      this.slides.forEach((slide) => {
        const slideUrl = slide.dataset.slideUrl;
        if (!slideUrl) return;

        slide.addEventListener('click', (event) => {
          if (event.target.closest('a, button, input, select, textarea, [data-hsc-prev], [data-hsc-next], [data-hsc-dot]')) {
            return;
          }

          window.location.href = slideUrl;
        });
      });

      this.dots = Array.from(this.querySelectorAll('[data-hsc-dot]'));
      this.prevButton = this.querySelector('[data-hsc-prev]');
      this.nextButton = this.querySelector('[data-hsc-next]');
      this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      this.index = this.index >= 0 ? this.index : 0;
      this.timer = null;
      this.raf = null;
      this.resizeTimer = null;
      this.pointerStartX = 0;
      this.pointerStartY = 0;
      this.pointerActive = false;
      this.isHovering = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (this.slides.length === 0) return;

      this.goTo = this.goTo.bind(this);
      this.next = this.next.bind(this);
      this.prev = this.prev.bind(this);
      this.startAutoplay = this.startAutoplay.bind(this);
      this.stopAutoplay = this.stopAutoplay.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.handleResize = this.handleResize.bind(this);

      this.prevButton?.addEventListener('click', this.prev);
      this.nextButton?.addEventListener('click', this.next);
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.hscDot), true));
      });

      this.addEventListener('keydown', this.handleKeydown);
      this.addEventListener('pointerdown', this.handlePointerDown, { passive: true });
      this.addEventListener('pointerup', this.handlePointerUp, { passive: true });
      this.addEventListener('pointercancel', () => {
        this.pointerActive = false;
      });
      this.addEventListener('mouseenter', () => {
        this.isHovering = true;
        this.stopAutoplay();
      });
      this.addEventListener('mouseleave', () => {
        this.isHovering = false;
        this.startAutoplay();
      });
      window.addEventListener('resize', this.handleResize);

      this.goTo(this.index, false);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.raf) window.cancelAnimationFrame(this.raf);
      if (this.resizeTimer) window.clearTimeout(this.resizeTimer);
      window.removeEventListener('resize', this.handleResize);
    }

    normalizeIndex(index) {
      const total = this.slides.length;
      return ((index % total) + total) % total;
    }

    goTo(index, resetTimer) {
      if (this.slides.length < 1) return;
      const nextIndex = this.normalizeIndex(index);
      if (nextIndex === this.index && resetTimer) {
        this.startAutoplay();
        return;
      }

      this.index = nextIndex;

      if (this.raf) window.cancelAnimationFrame(this.raf);
      this.raf = window.requestAnimationFrame(() => {
        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === this.index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === this.index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      });

      if (resetTimer) this.startAutoplay();
    }

    next() {
      this.goTo(this.index + 1, true);
    }

    prev() {
      this.goTo(this.index - 1, true);
    }

    startAutoplay() {
      this.stopAutoplay();
      if (this.dataset.autoplay !== 'true') return;
      if (this.slides.length < 2) return;
      if (this.isHovering) return;
      const speed = Number(this.dataset.speed) || 5000;
      this.timer = window.setInterval(() => this.goTo(this.index + 1, false), speed);
    }

    stopAutoplay() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    handleKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.prev();
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.next();
      }
    }

    handlePointerDown(event) {
      if (this.slides.length < 2) return;
      this.pointerActive = true;
      this.pointerStartX = event.clientX;
      this.pointerStartY = event.clientY;
    }

    handlePointerUp(event) {
      if (!this.pointerActive) return;
      this.pointerActive = false;
      const deltaX = event.clientX - this.pointerStartX;
      const deltaY = event.clientY - this.pointerStartY;
      if (Math.abs(deltaX) < 44) return;
      if (Math.abs(deltaY) > Math.abs(deltaX)) return;
      if (deltaX < 0) this.next();
      if (deltaX > 0) this.prev();
    }

    handleResize() {
      if (this.resizeTimer) window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => {
        this.goTo(this.index, false);
      }, 120);
    }
  }

  if (!customElements.get('hero-slider-custom')) {
    customElements.define('hero-slider-custom', HeroSliderCustom);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-slider"] && !Shopify.designMode) return;
  try {
    
  class ReviewSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.review-slider__track');
      this.slides = Array.from(this.querySelectorAll('.review-slider__slide'));
      this.prevButton = this.querySelector('[data-review-prev]');
      this.nextButton = this.querySelector('[data-review-next]');
      this.dots = Array.from(this.querySelectorAll('[data-review-dot]'));
      this.index = 0;
      this.timer = null;

      if (!this.track || this.slides.length < 2) return;

      this.update = this.update.bind(this);
      this.goTo = this.goTo.bind(this);
      this.next = this.next.bind(this);
      this.prev = this.prev.bind(this);
      this.restartAutoplay = this.restartAutoplay.bind(this);

      this.prevButton?.addEventListener('click', this.prev);
      this.nextButton?.addEventListener('click', this.next);
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.reviewDot)));
      });

      window.addEventListener('resize', this.update);
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', this.restartAutoplay);
      this.update();
      this.restartAutoplay();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.update);
      this.stopAutoplay();
    }

    get visibleSlides() {
      if (window.matchMedia('(min-width: 990px)').matches) return 3;
      if (window.matchMedia('(min-width: 760px)').matches) return 2;
      return 1;
    }

    get maxIndex() {
      return Math.max(0, this.slides.length - this.visibleSlides);
    }

    goTo(nextIndex) {
      this.index = Math.min(Math.max(nextIndex, 0), this.maxIndex);
      this.update();
      this.restartAutoplay();
    }

    next() {
      this.index = this.index >= this.maxIndex ? 0 : this.index + 1;
      this.update();
      this.restartAutoplay();
    }

    prev() {
      this.index = this.index <= 0 ? this.maxIndex : this.index - 1;
      this.update();
      this.restartAutoplay();
    }

    update() {
      this.index = Math.min(this.index, this.maxIndex);
      const offset = this.slides[0].getBoundingClientRect().width * this.index;
      this.track.style.transform = `translateX(-${offset}px)`;
      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === this.index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    restartAutoplay() {
      this.stopAutoplay();
      if (this.dataset.autoplay !== 'true') return;
      const interval = Number(this.dataset.interval) || 5000;
      this.timer = window.setInterval(this.next, interval);
    }

    stopAutoplay() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('review-slider')) {
    customElements.define('review-slider', ReviewSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
